import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import style from "./index.module.scss"
import WrapperContent from "../../../components/shared/WrapperContent";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import CloseIcon from "../../../components/shared/icons/CloseIcon";
import InputCustom from "../../../components/shared/forms/input-custom";
import UserIcon from "../../../components/shared/icons/UserIcon";
import PhoneIcon from "../../../components/shared/icons/PhoneIcon";
import EmailIcon from "../../../components/shared/icons/EmailIcon";
import CardIcon from "../../../components/shared/icons/CardIcon";
import AvatarCameraIcon from "../../../components/shared/icons/AvatarCameraIcon";
import { Driver, File, User } from '../../../services';
import { requestErrorDisplay } from '../../../utils';
import InputMask from 'react-input-mask';
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import Loading from '../../../components/shared/Loading/Loading';
import cn from 'classnames';
import moment from 'moment';
import InputCustomTemp from '../../../components/shared/forms/input-custom/InputCustomTemp';

const DriversCreatePage = () => {
  const { t } = useTranslation();
  const { user } = useSelector(state => state);
  const [searchParams] = useSearchParams()
  const navigate = useNavigate();
  const driversUrl = "/drivers"
  const backUrl = searchParams.get("redirectUrl") ? searchParams.get("redirectUrl") : driversUrl
  const [isLoading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [patronymic, setPatronymic] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [iin, setIin] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [issuedBy, setIssuedBy] = useState("");
  const [issuedDate, setIssuedDate] = useState("");
  const [carIdPhotoOne, setCarIdPhotoOne] = useState(null);
  const [carIdPhotoTwo, setCarIdPhotoTwo] = useState(null);
  const [userIdPhotoOne, setUserIdPhotoOne] = useState(null);
  const [userIdPhotoTwo, setUserIdPhotoTwo] = useState(null);
  const [userPhoto, setUserPhoto] = useState(null);
  const [phoneNumberExists, setPhoneNumberExists] = useState(false);
  const [phoneNumberErrorText, setPhoneNumberErrorText] = useState('');

  const validateFormatData = () => {
    // if (!name || name.trim().split(" ").length < 2) {
    //   toast.error(t('driversCreate.validation.fullNameRequired'));
    //   return false
    // }

    if (!name) {
      toast.error(t('driversCreate.validation.nameRequired'));
      return false
    }

    if (!surname) {
      toast.error(t('driversCreate.validation.surnameRequired'));
      return false
    }

    if (!patronymic) {
      toast.error(t('driversCreate.validation.patronymicRequired'));
      return false
    }

    if (!phoneNumber) {
      toast.error(t('driversCreate.validation.phoneRequired'));
      return false
    }

    // if (!email) {
    //   toast.error(t('driversCreate.validation.emailRequired'));
    //   return false
    // }

    if (!idNumber || idNumber.length !== 9) {
      toast.error(t('driversCreate.validation.idNumberInvalid'));
      return false
    }

    if (!iin || iin.length !== 12) {
      toast.error(t('driversCreate.validation.iinInvalid'));
      return false
    }

    if (!issuedBy) {
      toast.error(t('driversCreate.validation.issuedByRequired'));
      return false
    }

    if (!issuedDate) {
      toast.error(t('driversCreate.validation.issuedDateRequired'));
      return false
    }

    if (!carIdPhotoOne || !carIdPhotoTwo) {
      toast.error(t('driversCreate.validation.driverLicensePhotosRequired'));
      return false
    }

    if (!userIdPhotoOne || !userIdPhotoTwo) {
      toast.error(t('driversCreate.validation.idPhotosRequired'));
      return false
    }

    if (!userPhoto) {
      toast.error(t('driversCreate.validation.selfieRequired'));
      return false
    }
    return true
  }
  const onSubmit = () => {
    if (!validateFormatData()) {
      return false
    }
    setLoading(true)
    const data = {
      name: name,
      surname: surname,
      patronymic: patronymic,
      phoneNumber: phoneNumber.replace(/[^\d]/g, ''),
      email,
      iin,
      idNumber,
      issuedDate: formatIssuedDate(issuedDate),
      issuedBy: issuedBy,
    }

    Driver.createDriverByExpeditor(data)
      .then(res => res.data)
      .then(async data => {
        const driverId = data.id
        if (carIdPhotoOne) {
          await uploadFile({
            driverId,
            side: 0,
            file: carIdPhotoOne,
            type: 6 // Водительское удостоверение
          })
        }
        if (carIdPhotoTwo) {
          await uploadFile({
            driverId,
            side: 1,
            file: carIdPhotoTwo,
            type: 6 // Водительское удостоверение
          })
        }
        if (userIdPhotoOne) {
          await uploadFile({
            driverId,
            side: 0,
            file: userIdPhotoOne,
            type: 3 // Удостоверение личности
          })
        }
        if (userIdPhotoTwo) {
          await uploadFile({
            driverId,
            side: 1,
            file: userIdPhotoTwo,
            type: 3 // Удостоверение личности
          })
        }
        if (userPhoto) {
          await uploadFile({
            driverId,
            side: 0,
            file: userPhoto,
            type: 8 // селфи
          })
        }
        toast.success(t('driversCreate.toast.driverAddedSuccess'));
        navigate(backUrl)
      })
      .catch(error => {
        requestErrorDisplay(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const checkPhoneNumber = async (number) => {
    try {
      const response = await User.checkPhone(number);
      setPhoneNumberExists(response.data.isExists);
    } catch (error) {
      console.error(t('driversCreate.errors.phoneCheckError'), error);
      setPhoneNumberExists(false);
      setPhoneNumberErrorText(t('driversCreate.errors.phoneCheckError'));
    }
  };

  useEffect(() => {
    const cleanedNumber = phoneNumber.replace(/[^\d]/g, '');

    const delayFetch = setTimeout(() => {
      if (cleanedNumber.length >= 11) {
        checkPhoneNumber(cleanedNumber);
      }
    }, 500);

    return () => clearTimeout(delayFetch);
  }, [phoneNumber]);

  const formatIssuedDate = (date) => {
    const [day, month, year] = date.split("-");
    if (!day || !month || !year) return "";
    return `${year}-${month}-${day}`;
  };

  const uploadFile = (data) => {
    const Formdata = new FormData()
    for (const dataKey in data) {
      Formdata.append(dataKey, data[dataKey])
    }
    return File.uploadDocumentDriver(Formdata)
  }

  return (
    <WrapperContent>
      <div className={style.wrapper}>
        <h1 className={style.title}>{t('driversCreate.title')}</h1>
        <div className={style.content}>
          <div className={style.field}>
            <span className={style.field_label}>{t('driversCreate.label.surname')}</span>
            <InputCustom
              placeholder={t('driversCreate.placeholder.enterSurname')}
              defaultValue={surname}
              onChangeValue={setSurname}
              prefixStart={<UserIcon />}
            />
          </div>
          <div className={style.field}>
            <span className={style.field_label}>{t('driversCreate.label.name')}</span>
            <InputCustom
              placeholder={t('driversCreate.placeholder.enterName')}
              defaultValue={name}
              onChangeValue={setName}
              prefixStart={<UserIcon />}
            />
          </div>
          <div className={style.field}>
            <span className={style.field_label}>{t('driversCreate.label.patronymic')}</span>
            <InputCustom
              placeholder={t('driversCreate.placeholder.enterPatronymic')}
              defaultValue={patronymic}
              onChangeValue={setPatronymic}
              prefixStart={<UserIcon />}
            />
          </div>
           <div className={style.field}>
            <span className={style.field_label}>{t('driversCreate.label.phoneNumber')}</span>
            <InputMask
              mask="+7 (999) 999-99-99"
              value={phoneNumber}
              onChange={(event) => setPhoneNumber(event.target.value)}
              placeholder="+7 (___) ___-__-__"
            >
              {(inputProps) => <input {...inputProps} type="text" className={style.input} />}
            </InputMask>
            {phoneNumberExists && <p className={style.error_message}>{phoneNumberErrorText || t('common.errors.phoneExistsDriver')}</p>}
          </div>
          <div className={style.field}>
            <span className={style.field_label}>Email
              <span className={style.optional}>{t('driversCreate.label.optional')}</span>
            </span>
            <InputCustom
              defaultValue={email}
              onChangeValue={setEmail}
              placeholder="example@mail.com"
              prefixStart={<EmailIcon />}
            />
          </div>
          <div className={style.field}>
            <span className={style.field_label}>{t('driversCreate.label.idNumber')}</span>
            <InputCustom
              defaultValue={idNumber}
              onChangeValue={setIdNumber}
              placeholder={t('driversCreate.placeholder.enter')}
              maxLength={9}
              prefixStart={<CardIcon />}
            />
          </div>
          <div className={style.field}>
            <span className={style.field_label}>{t('driversCreate.label.iinNumber')}</span>
            <InputCustom
              defaultValue={iin}
              onChangeValue={setIin}
              placeholder={t('driversCreate.placeholder.enter')}
              maxLength={12}
              prefixStart={<CardIcon />}
            />
          </div>
          <div className={style.field}>
            <span className={style.field_label}>{t('driversCreate.label.issuedBy')}</span>
            <InputCustom
              defaultValue={issuedBy}
              onChangeValue={setIssuedBy}
              placeholder={t('driversCreate.placeholder.enter')}
              prefixStart={<CardIcon />}
            />
          </div>
          <div className={style.field}>
            <span className={style.field_label}>{t('driversCreate.label.issuedDate')}</span>
            <InputMask
              value={issuedDate}
              maskChar={null}
              mask="99-99-9999"
              onChange={(event) => setIssuedDate(event.target.value)}
              disabled={false}
            >
              {(inputProps) => (
                <InputCustomTemp
                  {...inputProps}
                  onChangeValue={setIssuedDate}
                  placeholder="DD-MM-YYYY"
                  prefixStart={<CardIcon />}
                />
              )}
            </InputMask>

          </div>
          <div className={style.field}>
            <span className={style.field_label}>{t('driversCreate.label.driverLicensePhotos')}</span>
            <div className={style.field_col_2}>
              <label className={style.field_upload}>
                <AvatarCameraIcon fill={"#C3C5CA"} />
                <span>{carIdPhotoOne?.name || t('driversCreate.button.frontSide')}</span>
                <input
                  type="file"
                  accept="image/webp, image/pbm, image/gif, image/jpeg, image/png, image/tiff"
                  onChange={(event) => setCarIdPhotoOne(event.target.files[0])}
                />
              </label>
              <label className={style.field_upload}>
                <AvatarCameraIcon fill={"#C3C5CA"} />
                <span>{carIdPhotoTwo?.name || t('driversCreate.button.backSide')}</span>
                <input
                  type="file"
                  accept="image/webp, image/pbm, image/gif, image/jpeg, image/png, image/tiff"
                  onChange={(event) => setCarIdPhotoTwo(event.target.files[0])}
                />
              </label>
            </div>
          </div>
          <div className={style.field}>
            <span className={style.field_label}>{t('driversCreate.label.idPhotos')}</span>
            <div className={style.field_col_2}>
              <label className={style.field_upload}>
                <AvatarCameraIcon fill={"#C3C5CA"}/>
                <span>{userIdPhotoOne?.name || t('driversCreate.button.frontSide')}</span>
                <input
                    type="file"
                    accept="image/webp, image/pbm, image/gif, image/jpeg, image/png, image/tiff"
                    onChange={(event) => setUserIdPhotoOne(event.target.files[0])}
                />
              </label>
              <label className={style.field_upload}>
                <AvatarCameraIcon fill={"#C3C5CA"}/>
                <span>{userIdPhotoTwo?.name || t('driversCreate.button.backSide')}</span>
                <input
                    type="file"
                    accept="image/webp, image/pbm, image/gif, image/jpeg, image/png, image/tiff"
                    onChange={(event) => setUserIdPhotoTwo(event.target.files[0])}
                />
              </label>
            </div>
          </div>
          <div className={style.field}>
            <span className={style.field_label}>{t('driversCreate.label.selfieWithLicense')}</span>
            <div className={style.field_col_2}>
              <label className={style.field_upload}>
                <AvatarCameraIcon fill={"#C3C5CA"}/>
                <span>{userPhoto?.name || t('driversCreate.button.addPhoto')}</span>
                <input
                    type="file"
                    accept="image/webp, image/pbm, image/gif, image/jpeg, image/png, image/tiff"
                  onChange={(event) => setUserPhoto(event.target.files[0])}
                />
              </label>
            </div>
          </div>
          <button
            className={cn(style.button_upload, { [style.button_upload_loading]: isLoading })}
            onClick={() => onSubmit()}
          >
            {!isLoading && <span>{t('driversCreate.button.confirm')}</span>}
            {isLoading && <Loading inBlock marginBottom={0} />}
          </button>
        </div>
        <Link to={backUrl} className={style.buttonCancel}>
          {t('driversCreate.button.cancel')}
        </Link>
        <Link to={backUrl} className={style.buttonClose}>
          <CloseIcon />
        </Link>
      </div>
    </WrapperContent>
  );
};

export default DriversCreatePage;
